var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.81 8.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #313a4e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.05,4.33H1.92c-.11,0-.19-.09-.19-.19s.09-.19.19-.19h2.13c.11,0,.19.09.19.19s-.09.19-.19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.06,4.28c-.11,0-.19-.09-.19-.19V1.09c0-.11.09-.19.19-.19s.19.09.19.19v3c0,.11-.09.19-.19.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.14,8.28C1.86,8.28,0,6.42,0,4.14S1.86,0,4.14,0c.94,0,1.87.33,2.6.92.72.58,1.23,1.4,1.44,2.3.02.1-.04.21-.15.23-.1.02-.21-.04-.23-.15-.19-.82-.65-1.55-1.3-2.08-.66-.54-1.5-.83-2.36-.83C2.07.39.39,2.07.39,4.14s1.68,3.75,3.75,3.75c.45,0,.88-.08,1.3-.23.1-.04.21.01.25.12.04.1-.01.21-.12.25-.46.17-.94.25-1.43.25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.57,7.71s-.04,0-.06-.01c-.59-.2-1.11-.55-1.51-1-.36-.41-.59-.88-.65-1.32-.06-.44.07-.89.34-1.2.23-.27.57-.41.93-.41.49,0,.76.22.95.45.19-.23.46-.45.95-.45.37,0,.7.15.93.41.27.31.39.75.34,1.2-.06.44-.29.91-.65,1.32-.4.45-.92.8-1.51,1-.02,0-.04.01-.06.01ZM5.62,4.15c-.26,0-.48.1-.64.28-.2.22-.29.56-.24.89.09.69.75,1.58,1.84,1.98,1.09-.4,1.75-1.3,1.84-1.98.04-.34-.05-.67-.24-.89-.16-.18-.38-.28-.64-.28-.44,0-.6.23-.79.49h0c-.04.06-.1.09-.16.09h0c-.06,0-.12-.03-.16-.08h0c-.19-.28-.35-.5-.79-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon 4.1abf96ce575907dbf7ec37bf9140751a.svg";
export { ForwardRef as ReactComponent };